import styled from 'styled-components';
import { H3, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(320)} 1fr;
  padding: ${spacing.x3} ${spacing.plusQuarter};
  @media only screen and (max-width: 870px) {
    grid-template-columns: 1fr; /** Fixes container issues when sidebar is removed on smaller screens */
  }
`;

export const Name = styled(H3)`
  display: inline-block;
  grid-area: name;
  height: ${pxToRem(34)};
  margin: 0;
`;

export const MainContent = styled.section`
  padding: 0 ${spacing.plusQuarter};
  white-space: nowrap;
`;
